// Sticky deck scroll
(function(){
  const stage = document.querySelector('.dd-decks');
  if(!stage) return;
  const slides = stage.querySelectorAll('.slide');
  const onScroll = () => {
    const r = stage.getBoundingClientRect();
    const total = stage.offsetHeight - window.innerHeight;
    const p = Math.min(1, Math.max(0, -r.top / total));
    const idx = Math.min(slides.length-1, Math.floor(p * slides.length));
    slides.forEach((s,i)=> s.classList.toggle('active', i===idx));
  };
  document.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
